import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import _isEmpty from 'lodash/isEmpty';
import { browserHistory } from 'react-router';
import { Form as FinalForm, FormSpy } from 'react-final-form';
import { Link, ButtonV2 } from '@zola/zola-ui';

import {
  renderEventTypeField,
  renderEventTitleField,
  renderEventDescriptionField,
  renderEventAttireField,
  renderEventToggles,
} from 'components/manage/VirtualEvents/common/FormFields/FormFields';

import Loader from 'components/common/ui/Loader';
import VirtualEventPreviewLive from './components/VirtualEventPreviewLive';

import { trackZoomSetupFlow } from '../../../../util/trackingHelper';

import css from './zoomEdit.module.less';

const ZoomEdit = ({
  zoomEvent,
  onFetchEventByHash,
  onFetchSuggestAttire,
  openSuggestionModal,
  updateZoomEvent,
  eventHash,
}) => {
  const [previewData, setPreviewData] = useState(null);

  useEffect(() => {
    if (eventHash && _isEmpty(zoomEvent)) onFetchEventByHash(eventHash);
    onFetchSuggestAttire();
  }, []);

  const onFormSave = values =>
    updateZoomEvent(values, 'We saved your virtual event page.').then(() => {
      trackZoomSetupFlow('Flow Completed', { flow_step_count: 2 });
      browserHistory.push(`/wedding/manage/website/virtual-event/${eventHash}`);
    });

  const onUpdate = data => setPreviewData(data);

  const setAttire = (args, state, { changeValue }) => {
    const value = args[0];
    changeValue(state, 'attire', () => value);
  };

  if (_isEmpty(zoomEvent)) {
    return (
      <div className={cx(css.container, css.loadingContainer)}>
        <Loader />
      </div>
    );
  }

  return (
    <div className={css.container}>
      <div className={css.column}>
        <h1 className={css.title}>Edit Your Virtual Event Page</h1>
        <FinalForm initialValues={zoomEvent} onSubmit={onFormSave} mutators={{ setAttire }}>
          {formProps => (
            <>
              <div className={css.fieldMarginBottom}>{renderEventTitleField()}</div>
              <div className={css.fieldMarginBottom}>{renderEventDescriptionField()}</div>
              <div className={css.fieldMarginBottom}>{renderEventTypeField()}</div>
              <div className={cx(css.attireFieldGroup, css.fieldMarginBottom)}>
                {renderEventAttireField(openSuggestionModal, val =>
                  formProps.form.mutators.setAttire(val)
                )}
              </div>
              {renderEventToggles()}
              <ButtonV2 type="submit" onClick={formProps.handleSubmit} disabled={!formProps.valid}>
                Save Virtual Event
              </ButtonV2>
              <FormSpy subscription={{ values: true }} onChange={props => onUpdate(props.values)} />
            </>
          )}
        </FinalForm>
        <Link
          role="button"
          onClick={() => browserHistory.push(`/wedding/manage/virtual/create/${eventHash}`)}
          arrow
          arrowPosition="prefix"
          className={css.back}
        >
          Edit Your Zoom Link
        </Link>
      </div>
      <div className={css.column}>
        <VirtualEventPreviewLive eventFormData={previewData} />
      </div>
    </div>
  );
};

ZoomEdit.propTypes = {
  zoomEvent: PropTypes.shape({}).isRequired,
  openSuggestionModal: PropTypes.func,
  updateZoomEvent: PropTypes.func,
  onFetchEventByHash: PropTypes.func,
  onFetchSuggestAttire: PropTypes.func,
  eventHash: PropTypes.string,
};

export default ZoomEdit;



// WEBPACK FOOTER //
// ./src/components/manage/VirtualEvents/ZoomEdit/ZoomEdit.jsx